module.exports = __webpack_public_path__ + "images/external_images/svg/components/desk-with-mac-primary-icon.svg";